import { useEffect, useRef } from 'react'

export interface VoiceTrack {
    peerId: string
    stream: MediaStream
}

export interface VoicePlaybackProps {
    tracks: VoiceTrack[]
    /** Volume por pessoa, de 0 a 1. Ausente = 1. */
    volumes: Record<string, number>
    /** Silencia tudo de uma vez, sem mexer nos volumes individuais. */
    deafened: boolean
}

/**
 * Toca a voz de quem esta na sala.
 *
 * Fica fora do palco de proposito: voz nao tem imagem, e amarrar o audio a um
 * tile faria a pessoa sumir da conversa quando o tile dela saisse da tela (no
 * modo destaque, por exemplo).
 */
export function VoicePlayback({ tracks, volumes, deafened }: VoicePlaybackProps) {
    return (
        <div className="sr-only" aria-hidden>
            {tracks.map((track) => (
                <VoiceElement
                    key={`${track.peerId}:${track.stream.id}`}
                    stream={track.stream}
                    volume={deafened ? 0 : volumes[track.peerId] ?? 1}
                />
            ))}
        </div>
    )
}

function VoiceElement({ stream, volume }: { stream: MediaStream; volume: number }) {
    const ref = useRef<HTMLAudioElement>(null)

    useEffect(() => {
        const element = ref.current
        if (!element) return
        element.srcObject = stream
        // O navegador so libera autoplay com som depois de um gesto — e entrar
        // na sala ja foi um clique, entao aqui isso passa. Se falhar, o catch
        // evita quebrar o resto do render.
        void element.play().catch(() => undefined)
    }, [stream])

    useEffect(() => {
        if (ref.current) ref.current.volume = Math.max(0, Math.min(1, volume))
    }, [volume])

    return <audio ref={ref} autoPlay playsInline />
}
